<template>
  <div class="login"  v-show="isFS">
    <header class="login-header">
      <div class="left">
        <img class="logo" :src="loginIcon" alt />
        <van-dropdown-menu class="account-list">
          <van-dropdown-item v-model="currentAccount" :options="accountList" />
        </van-dropdown-menu>
      </div>
      <div class="right"></div>
    </header>
    <van-cell-group>
      <van-field clearable label="用户名" v-model="user" placeholder="请输入用户名"></van-field>
      <van-field
        :type="this.passwordType"
        label="密码"
        v-model="pwd"
        placeholder="请输入密码"
        right-icon="eye-o"
        @click-right-icon="toggleSee"
      ></van-field>
    </van-cell-group>

    <div class="login-btn">
      <van-button type="info" round @click="loginBtn">登录</van-button>
      <a @click="visitBtn" class="login-btn-footer">访客预约 ></a>
    </div>
      
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";
const loginIcon = require("@/assets/Login-logo.png");
export default {
  name: "Login",
  data() {
    return {
      isFS:false,
      passwordType: "password",
      loginIcon: loginIcon,
      accountList: [],
      currentAccount: "",
      user: "",
      pwd: "",
      RouteUrl:'',//直接登录
      // wechat
      accountID: "",
      openID: "",

      // dingtalt
      code: {},
      dingUseId: "",
      notInDingTalk: "" // 是否来自钉钉
    };
  },
  created() {
    this.notInDingTalk = dd.env.platform === "notInDingTalk";
      if (!this.notInDingTalk&&this.corpId!=='') {
        // this.dingTalkInfo();
        this.getAccountInfo()
      } else {
        this.getURLInfo();
      }
  },
  watch:{
    currentAccount(val){
      if(val){
        localStorage.setItem('accountId',val)
      }
    }
  },
  methods: {
    getURLInfo() {
      if(this.$route.query.isApplyDetails || this.$route.query.isApplyDetails===undefined){
        this.isFS = true
      }
      let domainUrl = ''
      if (document.URL.indexOf('?') > -1) {
        domainUrl = document.URL.split('?')
      }
      if (domainUrl.length > 1){
        let third = domainUrl[1].split('&')
        let loginThird = 0
        let options = {
          AccountID: '',
          UserName: '',
          Token: '',
        }
        for (let i = 0, len = third.length; i < len; i++) {
          let o = third[i].split('=')[0]
          if (o === 'accountid' || o === 'AccountID') {
            options.AccountID = Number(third[i].split('=')[1])
          }
          if (o === 'username' || o === 'UserName') {
            options.UserName = third[i].split('=')[1]
          }
          if (o === 'token' || o === 'Token') {
            options.Token = third[i].split('=')[1]
          }
          if (o === 'loginThird' || o === 'LoginThird') {
            loginThird = Number(third[i].split('=')[1])
          }
          //直接登录
          if(o === 'RouteUrl'){
            this.RouteUrl = decodeURIComponent(third[i].split('=')[1])
          }
        }
        if (loginThird === 1) {
          this.getInfo(options)
        }else{
          if(this.RouteUrl) {//直接跳某个模块
            this.xy.removeCookie('.XYTOKEN')
            this.xy.setCookie(options.Token)
            localStorage.setItem("RouteUrl", this.RouteUrl);
            // this.$router.push(`${RouteUrl}`);
            this.$router.push('/xyIndex')
          }else{
            let localUrl = window.location.href.split("?")[1];
            let items = localUrl.split("&");
            let item;
            for (let i = 0; i < items.length; i++) {
              item = items[i].split("=");
              if (item[0].toLowerCase() === "accountid") {
                this.accountID = item[1];
              }
              if (item[0].toLowerCase() === "openid") {
                this.openID = item[1];
              }
              if (item[0].toLowerCase() === "token") {
                this.xy.removeCookie('.XYTOKEN')
                this.xy.setCookie(item[1])
                this.xy.msgSuc('登录成功')
                if(this.$route.query.isApplyDetails){
                  this.$router.push('/home/VisitApplyDetails');
                }else{
                  this.$router.push('/xyIndex')
                }
              }
            }
          }
        }
      }
      this.weChatLogin();
    },
    async getInfo (val) {      
      this.isFS = false
      this.xy.loading()
      let res = await this.xyapi.post(`${this.xyMApi}/xy/login/CasLogin`, val, true)
      if (res.success) {
        let token = res.data.token
        localStorage.setItem('webSiteTitle', '')
        if (token) {
          this.xy.setCookie(token)
          localStorage.setItem('role', res.data.role)
          if(this.RouteUrl){
            localStorage.setItem("RouteUrl", this.RouteUrl);
          }
          this.xy.msgSuc('登录成功')
          // Todo 登陆路由
          this.$router.push('/xyIndex')
        }
      } else {
        this.xy.msgError(res.msg)
        this.isFS = true
      }
      this.xy.unloading()
    },
    //钉钉授权
    dingTalkInfo() {
      this.isFS = true
      let that =this
      dd.ready(()=> {
        dd.runtime.permission.requestAuthCode({
          // TODO: 发布正式站时需要调整，详见 README.md 以进行修改
          corpId: this.corpId,
          onSuccess: function(result) {
            that.getUserMsg(result)
          },
          onFail: function(err) {
            console.log(err)
            that.xy.msgError(err);
          }
        })
      })
    },
    // 钉钉获取用户id
    getUserMsg(DDResult) {
      this.xyapi.get(`${this.xyMApi}/msg/api/WeiXin/GetDDUserInfoByCode`,{
        code: DDResult.code.toString(),
        accountID: this.accountList[0].value
      }).then(res=>{
        if (res.success) {
          this.dingUseId = res.data.userid;
          // this.getAccountInfo();
          this.dingTalkLogin()
        } else {
          this.xy.msgError(res.msg)
        }
      });
    },

    // 钉钉登陆
    dingTalkLogin() {
      if(this.currentAccount!==''&&this.dingUseId!==''){
        let params = {
          AccountID:this.currentAccount,
          DtUserID: this.dingUseId
        };
        this.xyapi.post(
          this.xyMApi + "/xy/login/DingTalkLogin",
          params,
          true
        ).then(res => {
          this.xy.unloading();
          if (res.success) {
            window.localStorage.setItem("webSiteTitle", this.accountList[0].text);
            this.xy.setCookie(res.data.token);
            localStorage.setItem("role", res.data.role);
            if (this.xy.getCookie(".XYTOKEN")) {
              let routers =
                localStorage.getItem("role") === "4" ? "/xyParent" : "/xyIndex";
                if(this.$route.query.isApplyDetails){
                  this.$router.push('/home/VisitApplyDetails');
                }else{
                  this.$router.push(routers);
                }
            } else {
              this.xy.msgError("登录失败");
            }
          }else{
            this.isFS = true
            this.$notify({ type: "danger", message: res.msg });
          }
        })
      }else{
        this.isFS = true
      }
    },

    weChatLogin() {
      if (this.accountID > 0 && this.openID !== "") {
        this.getWeChatUserInfo();
      } else {
        this.getAccountInfo();
      }
    },
    async getWeChatUserInfo() {
      let LoginViewModel = {
        AccountID: this.accountID,
        OpenID: this.openID
      };
      this.xy.loading();
      let res = await this.xyapi.post(
        this.xyMApi + "/xy/login",
        LoginViewModel
      );
      if (res.success) {
        this.xy.removeCookie('.XYTOKEN')
        localStorage.setItem("role", res.data.role);
        this.xy.setCookie(res.data.token);
        this.getOneAccountInfo();
      } else {
        this.xy.msgError(res.data.msg);
      }
      this.xy.unloading();
    },
    toggleSee() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    async loginBtn() {
      this.xy.loading();
      let params = {
        AccountID: this.currentAccount,
        LoginId: this.user,
        Password: this.xy.encrypt(this.pwd)
      };
      let res = await this.xyapi.post(
        this.xyMApi + "/xy/login",
        params
      );
      if (res.success) {
        let value = res.data.token;
        localStorage.setItem("role", res.data.role);
        let webSiteTitle;
        this.accountList.forEach(value => {
          if (this.currentAccount === value.value) {
            webSiteTitle = value.text;
            localStorage.setItem("webSiteTitle", webSiteTitle);
          }
        });
        if (value) {
          this.xy.setCookie(value);
          if (this.xy.getCookie(".XYTOKEN")) {
            this.xy.msgSuc("登录成功");
            //let routers = res.data.role === 4 ? "/xyParent" : "/xyIndex";
            let routers = "/xyIndex"
            if(this.$route.query.isApplyDetails){
              this.$router.push('/home/VisitApplyDetails');
            } else{
              // if(res.data.role!==4){
                this.$router.push(routers);
              // }
              // else{
              //   this.xy.msgError("家长账户暂无移动端功能");
              // }
            }
          } else {
            this.xy.msgError("登录失败");
          }
        } else {
          this.xy.msgError("登录失败");
        }
      } else {
        this.xy.msgError("登录失败");
      }
    },
    visitBtn() {
      console.log(22)
      this.$router.push('visitLogin')
    },
    //获取单个校区信息
    async getOneAccountInfo() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/login/AccountInfo"
      );
      if (res.success) {
        window.localStorage.setItem("webSiteTitle", res.data.AccountName);
        //this.xy.setCookie(".ACCOUNTNAME", res.data.AccountName);
        // 获取微信推送消息id
        this.xy.parseQueryString();
        let msgUrl = window.location.href.split("?"),
          msgOpenUrl = "";
        if (msgUrl[1].indexOf("MessageID") > -1) {
          msgOpenUrl = msgUrl[1].split("MessageID=");
          msgOpenUrl = msgOpenUrl[1];
        }
        if (msgOpenUrl) {
          window.localStorage.setItem("msgUrl", msgOpenUrl);
        } else {
          window.localStorage.setItem("msgUrl", "");
        }

        if (this.xy.getCookie(".XYTOKEN")) {
            let routers =
              localStorage.getItem("role") === "4" ? "/xyParent" : "/xyIndex";
            if(this.$route.query.isApplyDetails){
              this.$router.push('/home/VisitApplyDetails');
            }else{
              this.$router.push(routers);
            }
        } else {
          this.xy.msgError("登录失败");
        }
      } else {
        this.$notify({ type: "danger", message: res.msg });
      }
      this.xy.unloading();
    },
    //获取所有校区信息
    async getAccountInfo() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/login/AccountsInfo"
      );
      if (res.success) {
        this.accountList = res.data.map(value => ({
          text: value.AccountName,
          value: value.AccountID,
          Icon: value.Icon
        }));
        this.currentAccount = this.accountList.length > 0 ? this.accountList[0].value : "";
        this.loginIcon=this.accountList[0].Icon!==''?this.accountList[0].Icon:loginIcon
        if (!this.notInDingTalk) {
          // this.dingTalkLogin();
          this.dingTalkInfo();
        }
      } else {
        this.$notify({ type: "danger", message: res.msg });
      }
      this.xy.unloading();
    },
    accountListChange(val){
      let index =this.accountList.map(item=>{return item.value}).indexOf(val)
      this.loginIcon=this.accountList[index].Icon!==''?this.accountList[0].Icon:loginIcon
    }
  }
};
</script>
<style lang="less">
.login {
  [class*="van-hairline"]:after {
    border: 0;
  }

  height: 100%;
  background: #fff;
  font-size: 24px;

  .van-dropdown-menu__item {
    padding-left: 46px;
    justify-content: flex-start;
  }

  .van-cell-group {
    padding: 0 32px;
  }

  .login-header {
    display: flex;

    .left {
      flex: 1;
      position: relative;

      .logo {
        width: 440px;
        height: 140px;
        position: absolute;
        left: 68px;
        top: 72px;
      }

      .account-list {
        margin-top: 500px;
      }
    }

    .right {
      width: 411px;
      height: 628px;
      background-image: url("../../../../assets/loginbg.png");
      -webkit-background-size: 100% 100%;
      background-size: 100% 100%;
    }
  }

  .login-btn {
    text-align: center;
    margin-top: 150px;

    button {
      width: 427px;
      height: 90px;
    }
  }
  .login-btn-footer{
    display: block;
    color: #4196ff;
    text-align: center;
    padding:8% 0 10% 0;
    font-size: 30px;
    background-color: #ffffff;
  }
}
</style>
